export default __webpack_public_path__ + "static/gameshow-32ce51ac3dc7b9928e9166a888e0fd4e.png";